<script setup lang="ts">
useHead({
  bodyAttrs: {
    class: 'dark:bg-gray-950'
  }
})
</script>

<template>
  <div class="h-screen flex flex-col items-center justify-between">
    <div class="relative flex justify-center items-center w-full gap-4 p-4">
      <div class="font-bold text-2xl text-primary-600 dark:text-primary-400">
        <img src="../public/图片1.png" class="h-6" alt="" srcset="">
      </div>
      <div class="font-bold text-2xl text-primary-600 dark:text-primary-400">
        <img src="../public/icomfit_logo.png" class="h-6" alt="" srcset="">
      </div>
    </div>
    <div class="relative w-full">
      <nuxt-page />
    </div>
    <div class="relative w-full">
      <div class="p-4 bg-primary-600 dark:bg-primary-700 text-gray-100 dark:text-gray-300">
        <div class="flex flex-col items-center justify-center">
          <div>
            <img src="../public/logo.png" alt="" srcset="">
          </div>
          <div>
            维视艾康特(广东)医疗科技股份有限公司
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fixed top-2 right-2">
    <UColorModeButton />
  </div>
</template>

<style scoped>
.gradient {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(50% 50% at 50% 50%, rgb(var(--color-primary-500) / 0.25) 0, #FFF 100%);

}

.dark {
  .gradient {
    background: radial-gradient(50% 50% at 50% 50%, rgb(var(--color-primary-400) / 0.1) 0, rgb(var(--color-gray-950)) 100%);
  }
}

.overlay {
  background-size: 100px 100px;
  background-image:
    linear-gradient(to right, rgb(var(--color-gray-200)) 0.5px, transparent 0.5px),
    linear-gradient(to bottom, rgb(var(--color-gray-200)) 0.5px, transparent 0.5px);
  background-position: center;
}
.dark {
  .overlay {
    background-image:
      linear-gradient(to right, rgb(var(--color-gray-900)) 0.5px, transparent 0.5px),
      linear-gradient(to bottom, rgb(var(--color-gray-900)) 0.5px, transparent 0.5px);
  }
}
</style>
